export default __webpack_public_path__ + "static/media/amertrad8.6f87b11a.png";